var BaseView = (function () {

    var _globalEventHandler = $({});

    var _hiddenClass = 'hidden-block';

    var _events = {
        payButtonClick: 'payButtonClick',

        changeDeliverySectionMode: 'changeDeliverySectionMode',

        displayGiftForm: 'displayGiftForm',
        hideGiftForm: 'hideGiftForm' 
    };

    var _deliverySectionMode = {
        general: 0,
        gift: 1,
        embeddedLogin: 2
    };
    var _currentDeliverySectionMode = _deliverySectionMode.general;

    return Backbone.View.extend({
        
        constructor: function (opts) {
            var update = _.bind(this.__update, this);
            app.checkout.orderXhr.done(update);
            app.checkout.onUpdate(update);

            _.bindAll(this, '__update');

            Backbone.View.prototype.constructor.apply(this, arguments);
        },

        __update: function(data) {
            this.setDeliverySectionMode(data.BasketMode);
        },

        /* Switch between delivery sections (auth / delivery / gift delivery) */
        deliverySectionMode: _deliverySectionMode,
        setDeliverySectionMode: function (mode, opts) {
            if (mode === undefined || mode === null) {
                mode = this.getDeliverySectionMode();
            } else if (!this.settings('GiftEnabled') && mode === _deliverySectionMode.gift) {
                mode = _deliverySectionMode.general;
            }
            _currentDeliverySectionMode = mode;
            _globalEventHandler.trigger(_events.changeDeliverySectionMode, mode, opts);
        },
        getDeliverySectionMode: function () {
            if (DisplayEmbeddedLoginForm()) {
                _currentDeliverySectionMode = _deliverySectionMode.embeddedLogin;
            } else if (_currentDeliverySectionMode === _deliverySectionMode.embeddedLogin) {
                _currentDeliverySectionMode = _deliverySectionMode.general;
            } else if (!this.settings('GiftEnabled')) {
                _currentDeliverySectionMode = _deliverySectionMode.general;
            }
            return _currentDeliverySectionMode;
        },
        onChangeDeliverySectionMode: function (fn) {
            if ($.isFunction(fn)) {
                _globalEventHandler.on(_events.changeDeliverySectionMode, fn);
            }
        },
        /* --------------------------------------------------------------------- */

        onPayButtonClick: function(fn) {
            if ($.isFunction(fn)) {
                _globalEventHandler.on(_events.payButtonClick, fn);
            }
        },
        beforePayButtonClickAsync: function() {
            _globalEventHandler.trigger(_events.payButtonClick);
            if (DisplayEmbeddedLoginForm()) {
                return new $.Deferred().reject().promise();
            }
            return new $.Deferred().resolve().promise();
        },

        onDisplayGiftForm: function (fn) {
            if ($.isFunction(fn)) {
                _globalEventHandler.on(_events.displayGiftForm, fn);
            }
        },
        onHideGiftForm: function (fn) {
            if ($.isFunction(fn)) {
                _globalEventHandler.on(_events.hideGiftForm, fn);
            }
        },

        settings: function(name) {
            var settings = $('@basket').data('settings') || {};
            if (name) return settings[name];
            return settings;
        }

    });
})();